var quantity = 1;
var unit_price = 0;
var shower_type_id = 0;
var shower_layout_id = 0;
var fraction_array = ['0', '1/16', '1/8', '3/16', '1/4', '5/16', '3/8', '7/16', '1/2', '9/16', '5/8', '11/16', '3/4', '13/16', '7/8', '15/16'];
const handleSizeEnabledFor = ['Most Popular', 'Square Handle', 'Ladder handle'];
let measurementImageUrl = '';
let handleSizeEl;
let finalMeasurementImgContainer;
let finalMeasurementImage;
const coloredGlassPercentageIncrease = 45;
const enduroShieldGlassMaxPrice = 50;

const enabled_shower_installation = false;

const showerTypeHandler = (ths) => {
    shower_type_id = ths.data('shower-type-id');

    $('.shower-layout').addClass('hidden');
    $('#shower-layout-'+shower_type_id).removeClass('hidden');
    $('#shower_type').val(ths.data('val'));

    navigate_to_step(2);
}

const showerLayoutHandler = (ths) => {
  var measurement_image = ths.find('.measurement_image').val();
  $('#shower_layout').val(ths.data('val'));
  $('#measurement_image').val(measurement_image);
  shower_layout_id = ths.data('shower-layout-id');
  $('.measurement_selected_image').attr('src', measurement_image)
  var html = prepare_measurement_layout();
  $('#select-shower-dimestions').html(html);

  var angles_html = get_shower_angles_html();
  $('#shower_angles').html(angles_html);

  navigate_to_step(3);
}

const navigate_to_step = function (step, update_hash = true) {
    if (step === 4 && !validateWallPlumbInputs()) {
      return false; // prevent moving forward
    }

    $('.shower_steps').hide();
    $('#shower-step'+step).show();

    $('.nav-tabs, .mobile_tabs').removeClass('active-tabs')
    $('#navtab_'+step).addClass('active-tabs');
    $('#mobile_navtab_'+step).addClass('active-tabs');

    if( update_hash ){
        update_url( step );
    }

    if(step > 1){
        var prev_step = step - 1;
        $('#navtab_'+prev_step).addClass('active-tab-heads');
        $('#mobile_navtab_'+prev_step).addClass('active-tab-heads');
    }

    if(screen.width>767){
        var scrollTo = "#__custom-shower-doors-steps";
    }else{
        var scrollTo = "#mobile_navtab_"+step;
    }

    $('html, body').animate({
          scrollTop: $(scrollTo).offset().top
      }, 800);

    if( step > 2 ){
        unit_price = calculate_price();
        display_price();
    }

    if (step === 3) {
      toggleWallPlumbOptions();
    }
}


function toggleWallPlumbOptions() {
    const yesOption = document.getElementById('walls_out_of_plumb_yes');
    const optionsDiv = document.getElementById('wall_out_of_plumb_options');

    const toggleOptionsVisibility = () => {
      optionsDiv.style.display = yesOption.checked ? 'flex' : 'none';
    };

    document.querySelectorAll('input[name="walls_out_of_plumb"]').forEach(input => {
      input.addEventListener('change', toggleOptionsVisibility);
    });
}

function validateWallPlumbInputs() {
  const yesSelected = document.getElementById('walls_out_of_plumb_yes')?.checked;
  if (!yesSelected) return true;

  const fields = [
    { id: 'topPlumb', label: 'Top' },
    { id: 'middlePlumb', label: 'Middle' },
    { id: 'bottomPlumb', label: 'Bottom' }
  ];

  let isValid = true;

  // Remove previous error messages
  document.querySelectorAll('.error-message').forEach(el => el.remove());

  fields.forEach(field => {
    const input = document.getElementById(field.id);
    const plumbRow = input.closest('.plumb-row-inner');
    const value = input.value.trim();

    if (value === '' || isNaN(value)) {
      isValid = false;
      
      input.style.border = '1px solid #FF4D4F';
      const error = document.createElement('span');
      error.className = 'error-message';
      error.textContent = 'This field cannot be empty and must be a number.';

      plumbRow.insertAdjacentElement('afterend', error);
    } else {
      input.style.border = '1px solid #ccc';
    }
  });

  return isValid;
}

$('input[name="glass_type"], input[name="glass_thickness"], input[name="royalty_shield"]').change(function() {
  unit_price = calculate_price();
  display_price();
});

const update_url = function( step ) {
    const title = 'step' + step;
    const obj = { Title: title, Url: '#'+ title };
    history.pushState(obj, obj.Title, obj.Url);
}

const get_shower_angles_html = function(){

      	var html = '';
    	var func_name = 'get_shower_angles_'+shower_type_id+'_'+shower_layout_id+'_args';

      	if (typeof window[func_name] === "function") {
            var $args = eval(func_name + "()");
          	var html = generate_angles_html($args);
        }

      	return html;
    }

const generate_angles_html = function($args){
    var html = '<h3>Angles</h3>';
    html += '<div class="d-block">';
    html += '<div class="input_checkbox">';
    html += '<input type="checkbox" name="angle_defaults" id="angle_defaults" value="1" checked/>';
    html += '<label>Use Standard</label>';
    html += '</div>';
    html += '<ul id="__angles_block" class="input_block">';
    html += '<li>';
    html += '<label>Degrees</label>';
    html += '</li>';
    for( i = 0; i < $args.length; i++ ){
        html += '<li>';
        html += '<div class="d-flex">';
        html += '<span>'+ $args[i]['label'] +'</span><input type="hidden" name="measure_angles['+i+'][label]" value="'+$args[i]['label']+'"/>';
        html += '<div class="form-group">';
        html += '<input type="number" class="form-control measure_angles" name="measure_angles['+i+'][degree]" value="'+ $args[i]['angle'] +'" />';
        html += '</div>';
        html += '</div>';
        html += '</li>';
    }
    html +=	'</ul>';
    html += '</div>';
  
    return html;
}

var get_measurement_html = function(){
  var html = '<table class="table">';
  html +='<thead>';
  html +='<tr>';
  html +='<th></th>';
  html +='<th>Inches</th>';
  html +='<th>Fraction of an Inch</th>';
  html +='</tr>';
  html +='</thead>';
  html +='<tbody>';

  var i = 0;
  $('input[name^="measurement"]').each(function(){
      var label = $('[name="measurement['+i+'][label]"]').val();
      var inches = $('[name="measurement['+i+'][inches]"]').val();
      var fraction = $('[name="measurement['+i+'][fraction]"]').val();

      html +='<tr>';
      html +='<td><span>'+label+'</span></td>';
      html +='<td>'+inches+'"</td>';
      html +='<td>'+fraction+'"</td>';
      html +='</tr>';
      i++;
  });

  html +='</tbody>';
  html +='</table>';

  return html;
}

var display_price = function(){
  var final_price = (quantity * unit_price);
  $('.final_price').text('$'+ final_price.toFixed(2));

  if(!shopPayEnabled) {
    return;
  }

  var installment_amount = 0;

  if( final_price <= 150 ) {
      installment_amount = (final_price / 4 ).toFixed(2);
      var installment_text = "Pay in full or in 4 interest-free installments of" + '<a>$'+ installment_amount + '</a> with';
  }
  else if (final_price > 150 && final_price <= 1000 ) {
      installment_amount = ( ( final_price + (final_price / 12 ) ) / 12 ).toFixed(2);
      var installment_text = "4 interest-free installments or from " + '<a>$' + installment_amount  + '/mo</a> with';
  }
  else if( final_price > 1000 ) {
      installment_amount = ( ( final_price + (final_price / 12 ) ) / 12 ).toFixed(2);
      var installment_text = "From " + '<a>$'+ installment_amount + '/mo</a> with';
  }

  $('#installment_li strong').html(installment_text);
}

var get_dimensions = function(){
  let dimensions = "";
  let i = 0;
  $('.measurement').each(function(){
      var label = $('[name="measurement['+i+'][label]"]').val();
      var inches = $('[name="measurement['+i+'][inches]"]').val()
      var fraction = $('[name="measurement['+i+'][fraction]"]').val()
      dimensions += label + ': '+ inches + '" ' + fraction + '", ';
      i++;
  });
  return dimensions.trim().slice(0, -1);
}

var get_measure_angles = function(){
  let measure_angles_text = '';
  let i = 0;
  $('.measure_angles').each(function(){
      const label = $('[name="measure_angles['+i+'][label]"]').val();
      const degree = $('[name="measure_angles['+i+'][degree]"]').val();
      measure_angles_text += label + ': '+ degree+ ', ';
      i++;
  });
  return measure_angles_text.trim().slice(0, -1);
}

var get_properties = function() {
  const walls_out_of_plumb = $('input[name="walls_out_of_plumb"]:checked').val();
  const topPlumbV = document.getElementById('topPlumb').value;
  const topPlumbFraction = document.getElementById('top-plumb-fractions').value;
  const middlePlumbV = document.getElementById('middlePlumb').value;
  const middlePlumbFraction = document.getElementById('middle-plumb-fractions').value;
  const bottomPlumbV = document.getElementById('bottomPlumb').value;
  const bottomPlumbFraction = document.getElementById('bottom-plumb-fractions').value;
  const plumbsWall = $('input[name="plumbs-wall"]:checked').val()

  let properties = {
        'Shower Type': $('#shower_type').val(),
        'Shower Layout': $('#shower_layout').val(),
        'Dimensions': get_dimensions(),
        'Glass Type': $('input[name="glass_type"]:checked').val(),
        'Glass Thickness': $('input[name="glass_thickness"]:checked').val(),
        'Royalty Shield': $('input[name="royalty_shield"]:checked').val(),
        "Hardware Finish": $('input[name="hardware_finish"]:checked').val(),
        "Attach Glass to Ceiling": $('input[name="attach_glass_to_ceiling"]:checked').val(),
        "Shower Walls Out of Plumb": walls_out_of_plumb
  };

  if(walls_out_of_plumb === 'Yes') {
    properties['Plumb Dimensions'] = `Top: ${topPlumbV}" ${topPlumbFraction}", Middle: ${middlePlumbV}" ${middlePlumbFraction}", Bottom: ${bottomPlumbV}" ${bottomPlumbFraction}"`;
    properties['Wall Plumb Side'] = `${plumbsWall}`;
  }

  if(enabled_shower_installation) {
    properties['Need Installation'] = $('input[name="need_installation"]:checked').val()
  }

  properties["Measurement Image"] = measurementImageUrl || finalMeasurementImage.attr('src');

  const shower_type = $('#shower_type').val().trim().toLowerCase();
  if( shower_type == 'fixed shower screen' ){
      properties['Installation Style'] = $('input[name="installation_style"]:checked').val();
  } else {
      const handleStyle = $('input[name="handle_style"]:checked').val();

      properties['Handle Style'] = handleStyle;

      if ($.inArray(handleStyle, handleSizeEnabledFor) !== -1) {
          properties['Handle Size'] = $('#handle_size').val();
      }
  }

  if($('#angle_defaults').length){
      const angle_defaults = $('#angle_defaults').is(":checked") ? 'Yes' : 'No';
      properties['Angles Defaults'] = angle_defaults;
      properties['Measure Angles'] = get_measure_angles();
  }

  return properties;
}

function getDefaultDimensions(showerTypeId, showerLayoutId) {
    const typeId = parseInt(showerTypeId);
    const layoutId = parseInt(showerLayoutId);

    const combinedId = `${typeId}.${layoutId}`;

    const defaultLayoutValues = [
        { id: '1.*', width: 30, height: 72, w1: 20, h1: 30 },
        { id: '1.5', width: 30, height: 72, w1: 20, h1: 60 },
        { id: '1.6', width: 30, height: 72, w1: 20, h1: 60 },
        { id: '2.*', width: 22, height: 70 },
        { id: '3.*', width: 60, height: 72, w1: 30, w2: 30, w3: 30 },
        { id: '4.*', width: 60, height: 70, w1: 30, w2: 30, w3: 30, h1: 35, h2:35 },
        { id: '5.*', width: 30, height: 72, w1: 30, w2: 30, w3: 30, w4: 30, w5: 30, h1: 72, h2: 72 },
        { id: '6.*', width: 60, height: 72, w1: 60, w2: 60, w3: 60, h1: 72, h2: 72 },
        { id: '7.*', width: 60, height: 72, w1: 60, h1: 36, h2: 36 },
        { id: '7.2', width: 44, height: 70 },
        { id: '8.*', width: 60, height: 72, w1: 60, h1: 36, h2: 36 },
        { id: '8.1', width: 44, height: 70, w1: 44 }
    ];

    // Function to match combinedId against wildcard patterns
    const matchWithWildcard = (idPattern, combinedId) => {
        // Convert wildcard (*) to regex (.*)
        const regexPattern = new RegExp(`^${idPattern.replace('*', '.*')}$`);
        return regexPattern.test(combinedId);
    };

    // First, try to find an exact match
    let matchedItem = defaultLayoutValues.find(item => item.id === combinedId);

    // If no exact match is found, look for a wildcard match
    if (!matchedItem) {
        matchedItem = defaultLayoutValues.find(item => matchWithWildcard(item.id, combinedId));
    }

    return matchedItem || {};
}

const maxheight = 96;

const get_layout1_1_args = () => {
    return [
        { label: 'W', start: 3, end: 96 },
        { label: 'H', start: 10, end: maxheight }
    ];
};

const get_layout1_2_args = () => {
    return [
        { label: 'W', start: 3, end: 96 },
        { label: 'H', start: 10, end: maxheight }
    ];
};

const get_layout1_3_args = () => {
    return [
        { label: 'W', start: 7, end: 96 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 72 },
        { label: 'H1', start: 1, end: maxheight },
    ];
};

const get_layout1_4_args = () => {
    return [
        { label: 'W', start: 7, end: 96 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 72 },
        { label: 'H1', start: 1, end: maxheight }
    ];
};

const get_layout1_5_args = () => {
    return [
        { label: 'W', start: 4, end: 100 },
        { label: 'H', start: 10, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'H1', start: 10, end: maxheight }
    ];
};

// window.get_shower_angles_1_5_args = function() {
//     return [
//       { label: 'D', angle: 90 }
//     ];
// }

const get_layout1_6_args = () => {
    return [
        { label: 'W', start: 4, end: 100 },
        { label: 'H', start: 10, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'H1', start: 10, end: maxheight }
    ];
};

// window.get_shower_angles_1_6_args = function() {
//     return [
//       { label: 'D', angle: 90 }
//     ];
// }

const get_layout2_1_args = () => {
    return [
        { label: 'W', start: 12, end: 36 },
        { label: 'H', start: 24, end: maxheight }
    ];
};

const get_layout2_2_args = () => {
    return [
        { label: 'W', start: 12, end: 36 },
        { label: 'H', start: 15, end: maxheight }
    ];
};

const get_layout2_3_args = () => {
    return [
        { label: 'W', start: 12, end: 100 },
        { label: 'H', start: 15, end: maxheight }
    ];
};

const get_layout3_1_args = () => {
    return [
        { label: 'W', start: 18, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 3, end: 100 }
    ];
};

const get_layout3_2_args = () => {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 }
    ];
};

const get_layout3_3_args = () => {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 }
    ];
};

const get_layout3_4_args = () => {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 0, end: 100 }
    ];
};

const get_layout3_5_args = function() {
  return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 0, end: 100 }
    ];
}

const get_layout3_6_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 3, end: 100 }
    ];
}

const get_layout3_7_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 }
    ];
}

const get_layout3_8_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 3, end: 100 }
    ];
}

const get_layout3_9_args = function() {
    return [
          { label: 'W', start: 14, end: 236 },
          { label: 'H', start: 15, end: maxheight },
          { label: 'W1', start: 12, end: 36 }
      ];
}

var get_layout3_10_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 0, end: 100 }
    ];
}

const get_layout3_11_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 0, end: 100 }
    ];
}

const get_layout3_12_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 4, end: 100 }
    ];
}

const get_layout3_13_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

const get_layout3_14_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

const get_layout3_15_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

const get_layout3_16_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 0, end: maxheight },
        { label: 'H1', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

const get_layout3_17_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 0, end: maxheight },
        { label: 'H1', start: 15, end: maxheight },
        { label: 'H2', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'W4', start: 3, end: 100 },
        { label: 'W5', start: 3, end: 100 },
    ];
}

const get_layout3_18_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 0, end: maxheight },
        { label: 'H1', start: 15, end: maxheight },
        { label: 'H2', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'W4', start: 3, end: 100 },
        { label: 'W5', start: 3, end: 100 },
    ];
}

const get_layout3_19_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 4, end: 100 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 10, end: maxheight }
    ];
}

const get_layout3_20_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 4, end: 100 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 10, end: maxheight }
    ];
}

/**** Corner Shower Starts ****/
const get_layout4_1_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 3, end: 60 }
    ];
}

window.get_shower_angles_4_1_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_2_args = function() {
    return [
        { label: 'W', start: 14, end: 150 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 4, end: 100 }
    ];
}

window.get_shower_angles_4_2_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

const get_layout4_3_args = function() {
    return [
        { label: 'W', start: 24, end: 136 },
        { label: 'H', start: 30, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 6, end: maxheight },
        { label: 'W1', start: 6, end: 100 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 0, end: 100 }
    ];
}

window.get_shower_angles_4_3_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_4_args = function() {
    return [
      { label: 'W', start: 12, end: 45 },
      { label: 'H', start: 15, end: maxheight },
      { label: 'W1', start: 3, end: 100 },
      { label: 'H1', start: 3, end: maxheight },
    ];
}

window.get_shower_angles_4_4_args = function() {
    return [
      { label: 'L', angle: 90}
    ];
}

const get_layout4_5_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 4, end: 100 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 10, end: maxheight }
    ];
}

window.get_shower_angles_4_5_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

const get_layout4_6_args = function () {
    return [
      { label: 'W', start: 14, end: 136 },
      { label: 'H', start: 15, end: maxheight },
      { label: 'W1', start: 3, end: 100 },
      { label: 'H1', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_4_6_args = function() {
    return [
      { label: 'R', angle: 90}
    ];
}

const get_layout4_7_args = function() {
    return [
      { label: 'W', start: 14, end: 136 },
      { label: 'H', start: 15, end: maxheight },
      { label: 'W1', start: 12, end: 36 },
      { label: 'W2', start: 3, end: 100 },
      { label: 'W3', start: 3, end: 100 },
    ];
}

window.get_shower_angles_4_7_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

const get_layout4_8_args = function() {
    return [
      { label: 'W', start: 14, end: 136},
      { label: 'H', start: 15, end: maxheight},
      { label: 'W1', start: 3, end: 100},
      { label: 'W2', start: 3, end: 100},
      { label: 'W3', start: 12, end: 60},
    ];
}

window.get_shower_angles_4_8_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_9_args = function(){
    return [
      { label: 'W', start: 14, end: 136},
      { label: 'H', start: 15, end: maxheight},
      { label: 'W1', start: 3, end: 100},
      { label: 'H1', start: 3, end: maxheight}
    ];
}

window.get_shower_angles_4_9_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_10_args = function() {
    return [
      { label: 'W', start: 14, end: 136 },
      { label: 'H', start: 15, end: maxheight },
      { label: 'W1', start: 3, end: 100 },
      { label: 'W2', start: 0, end: 100 },
      { label: 'W3', start: 12, end: 60 },
      { label: 'W4', start: 3, end: 100 },
      { label: 'H1', start: 0, end: maxheight },
      { label: 'H2', start: 15, end: maxheight },
    ];
}

window.get_shower_angles_4_10_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_11_args = function() {
    return [
      { label: 'W', start: 14, end: 136 },
      { label: 'H', start: 15, end: maxheight },
      { label: 'W1', start: 12, end: 36 },
      { label: 'W2', start: 0, end: 100 },
      { label: 'W3', start: 3, end: 100 },
      { label: 'W4', start: 0, end: 100 },
      { label: 'H1', start: 0, end: maxheight },
      { label: 'H2', start: 15, end: maxheight },
    ];
}

window.get_shower_angles_4_11_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

const get_layout4_12_args = function() {
    return [
      { label: 'W', start: 14, end: 100},
      { label: 'H', start: 15, end: maxheight},
      { label: 'W1', start: 3, end: 70},
      { label: 'H1', start: 10, end: maxheight}
    ];
}

window.get_shower_angles_4_12_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

var get_layout4_13_args = function() {

    return [
      { label: 'W', start: 14, end: 136},
      { label: 'H', start: 15, end: maxheight},
      { label: 'W1', start: 4, end: 100},
      { label: 'W2', start: 3, end: 36},
      { label: 'W3', start: 6, end: 100}
    ];
}

window.get_shower_angles_4_13_args = function() {
    return [
      { label: 'L', angle: 90 }
    ];
}

const get_layout4_14_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 6, end: 100 },
        { label: 'W2', start: 3, end: 36 },
        { label: 'W3', start: 4, end: 100 }
    ];
}

window.get_shower_angles_4_14_args = function() {
    return [
      { label: 'R', angle: 90 }
    ];
}

const get_layout4_15_args = function() {
    return [
        { label: 'W', start: 12, end: 36 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 }
    ];
}

window.get_shower_angles_4_15_args = function() {
    return [
      { label: 'D', angle: 90 }
    ];
}

const get_layout4_16_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 3, end: maxheight },
    ];
}

window.get_shower_angles_4_16_args = function() {
    return [
      { label: 'H', angle: 90 }
    ];
}

const get_layout4_17_args = function() {
    return [
        { label: 'W', start: 12, end: 36 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 }
    ];
}

window.get_shower_angles_4_17_args = function() {
    return [
      { label: 'D', angle: 90 }
    ];
}

const get_layout4_18_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 3, end: maxheight },
    ];
}

window.get_shower_angles_4_18_args = function() {
    return [
      { label: 'H', angle: 90 }
    ];
}

const get_layout4_19_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 }
    ];
}

window.get_shower_angles_4_19_args = function() {
    return [
      { label: 'D', angle: 90 }
    ];
}

const get_layout4_20_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_4_20_args = function() {
    return [
      { label: 'H', angle: 90 }
    ];
}

const get_layout4_21_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 }
    ];
}

window.get_shower_angles_4_21_args = function() {
    return [
      { label: 'D', angle: 90 }
    ];
}

const get_layout4_22_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_4_22_args = function() {
    return [
      { label: 'H', angle: 90 }
    ];
}

const get_layout4_23_args = function() {
    return [
        { label: 'W', start: 5, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 },
        { label: 'W2', start: 5, end: 120 },
    ];
}

const get_layout4_24_args = function() {
    return [
        { label: 'W', start: 5, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 },
        { label: 'W2', start: 5, end: 120 }
    ];
}

const get_layout4_25_args = function() {
    return [
        { label: 'W', start: 5, end: 120 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 },
        { label: 'W2', start: 5, end: 36 }
    ];
}

const get_layout4_26_args = function() {
    return [
        { label: 'W', start: 5, end: 120 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 36 },
        { label: 'W2', start: 5, end: 120 }
    ];
}

/**** CORNER SHOWER END ****/

/**** NEO ANGLE SHOWERS START ****/

const get_layout5_1_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 3, end: 100 },
        { label: 'W5', start: 3, end: 100 }
    ];
}

window.get_shower_angles_5_1_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_2_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

window.get_shower_angles_5_2_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_3_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
    ];
}

window.get_shower_angles_5_3_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_4_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_5_4_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_5_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_5_5_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_6_args = function() {
    return [
        { label: 'W', start: 12, end: 100 },
        { label: 'H', start: 3, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'W4', start: 3, end: 236 },
        { label: 'W5', start: 3, end: 100 }
    ];
}

window.get_shower_angles_5_6_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_7_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 }
    ];
}

window.get_shower_angles_5_7_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_8_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_5_8_args = function() {
    return [
      { label: 'R', angle: 135 },
      { label: 'L', angle: 135 },
    ];
}

const get_layout5_9_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_5_9_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout5_10_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_5_10_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout5_11_args = function() {
    return [
        { label: 'W', start: 10, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 }
    ];
}

const get_layout5_12_args = function() {
    return [
        { label: 'W', start: 10, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 }
    ];
}

const get_layout5_13_args = function() {
    return [
        { label: 'W', start: 10, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 },
        { label: 'H1', start: 5, end: maxheight }
    ];
}

const get_layout5_14_args = function() {
    return [
        { label: 'W', start: 10, end: 36 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 5, end: 120 },
        { label: 'H1', start: 5, end: maxheight }
    ];
}
/**** Neo Angle Showers Ends ****/


/**** Steam Showers Starts ****/
const get_layout6_1_args = function() {
    return [
        { label: 'W', start: 12, end: 36 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 14, end: 94 }
    ];
}

const get_layout6_2_args = function() {
    return [
        { label: 'W', start: 12, end: 50 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'H1', start: 14, end: 94 }
    ];
}

const get_layout6_3_args = function() {
    return [
        { label: 'W', start: 12, end: 72 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 0, end: 100 },
        { label: 'H1', start: 10, end: maxheight },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

const get_layout6_4_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 94 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

const get_layout6_5_args = function() {
    return [
        { label: 'W', start: 24, end: 100 },
        { label: 'H', start: 30, end: maxheight },
        { label: 'W1', start: 16, end: 80 },
        { label: 'H1', start: 24, end: 94 }
    ];
}

const get_layout6_6_args = function() {
    return [
        { label: 'W', start: 24, end: 100 },
        { label: 'H', start: 30, end: maxheight },
        { label: 'W1', start: 16, end: 80 },
        { label: 'H1', start: 24, end: 94 }
    ];
}

const get_layout6_7_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 2, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 2, end: 100 },
        { label: 'H1', start: 3, end: maxheight }
    ];
}

const get_layout6_8_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: maxheight },
        { label: 'H2', start: 3, end: maxheight },
        { label: 'H3', start: 12, end: 94 }
    ];
}

const get_layout6_9_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 0, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

const get_layout6_10_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 2, end: 100 },
        { label: 'W3', start: 0, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 3, end: 94 }
    ];
}

const get_layout6_11_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'H1', start: 3, end: 94 },
    ];
}

const get_layout6_12_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'H1', start: 4, end: 94 }
    ];
}

const get_layout6_13_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 4, end: 100 },
        { label: 'H1', start: 5, end: 94 }
    ];
}

const get_layout6_14_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 12, end: 36 },
        { label: 'W3', start: 4, end: 100 },
        { label: 'H1', start: 3, end: maxheight },
        { label: 'H2', start: 2, end: maxheight },
        { label: 'H3', start: 4, end: 94 }
    ];
}

const get_layout6_15_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'H3', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_6_15_args = function() {
    return [
        { label: 'L', angle: 90 },
    ];
}

const get_layout6_16_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 4, end: 100 },
        { label: 'W2', start: 6, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'H3', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_6_16_args = function() {
    return [
        { label: 'R', angle: 90 },
    ];
}

const get_layout6_17_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'H1', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_6_17_args = function() {
    return [
        { label: 'L', angle: 90 },
    ];
}

const get_layout6_18_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_18_args = function() {
    return [
        { label: 'R', angle: 90 },
    ];
}

const get_layout6_19_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'H3', start: 15, end: maxheight }
    ];
}

window.get_shower_angles_6_19_args = function() {
    return [
        { label: 'L', angle: 90 },
    ];
}

const get_layout6_20_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'W4', start: 0, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight },
        { label: 'H3', start: 3, end: maxheight }
    ];
}

window.get_shower_angles_6_20_args = function() {
    return [
        { label: 'R', angle: 90 },
    ];
}

const get_layout6_21_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 12, end: 36 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_21_args = function() {
    return [
        { label: 'R', angle: 90 },
    ];
}

const get_layout6_22_args = function() {
    return [
        { label: 'W', start: 14, end: 136 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_22_args = function() {
    return [
        { label: 'L', angle: 90 },
    ];
}

const get_layout6_23_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_23_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_24_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H2', start: 3, end: 94 },
        { label: 'H3', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_24_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_25_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 3, end: 100 },
        { label: 'W5', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_25_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_26_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_26_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_27_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 3, end: 94 },
        { label: 'H3', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_27_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_28_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_28_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_29_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_29_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_30_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 },
        { label: 'H2', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_30_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_31_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'W3', start: 12, end: 60 },
        { label: 'W4', start: 3, end: 100 },
        { label: 'W5', start: 3, end: 100 },
        { label: 'H1', start: 3, end: 94 }
    ];
}

window.get_shower_angles_6_31_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}

const get_layout6_32_args = function() {
    return [
        { label: 'W', start: 14, end: 236 },
        { label: 'H', start: 15, end: maxheight },
        { label: 'W1', start: 3, end: 100 },
        { label: 'W2', start: 3, end: 100 },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 3, end: 94 },
        { label: 'H3', start: 0, end: maxheight }
    ];
}

window.get_shower_angles_6_32_args = function() {
    return [
        { label: 'R', angle: 135 },
        { label: 'L', angle: 135 },
    ];
}
/**** Steam Showers Ends ****/


/**** Metro Sliding Shower Doors Starts ****/
const get_layout7_1_args = function() {
    return [
        { label: 'W', start: 30, end: 76 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'W1', start: 3, end: 76 }
    ];
}

const get_layout7_2_args = function() {
    return [
        { label: 'W', start: 35, end: 76 },
        { label: 'H', start: 40, end: maxheight }
    ];
}

const get_layout7_3_args = function() {
    return [
        { label: 'W', start: 40, end: 76 },
        { label: 'H', start: 40, end: maxheight },
        { label: 'H1', start: 0, end: maxheight },
        { label: 'H2', start: 3, end: maxheight },
        { label: 'W1', start: 3, end: 76 }
    ];
}

const get_layout7_4_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight },
      { label: 'W1', start: 3, end: 76 }
    ];
}

const get_layout7_5_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight },
      { label: 'H1', start: 0, end: maxheight },
      { label: 'H2', start: 3, end: maxheight },
      { label: 'W1', start: 3, end: 76 }
    ];
}

const get_layout7_6_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight }
    ];
}
/**** Metro Sliding Shower Doors Ends ****/


/**********************************************
************ BYPASS SLIDING DOORS *************
***********************************************/

// 1. Linear Bypass
const get_layout8_1_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight }
    ];
}

const get_layout8_2_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight },
      { label: 'W1', start: 3, end: 76 },
    ];
}

const get_layout8_3_args = function() {
    return [
      { label: 'W', start: 40, end: 76},
      { label: 'H', start: 40, end: maxheight },
      { label: 'W1', start: 3, end: 76 },
    ];
}

const get_layout8_4_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight },
      { label: 'H1', start: 3, end: maxheight },
      { label: 'H2', start: 3, end: maxheight },
      { label: 'W1', start: 3, end: 76 },
    ];
}

const get_layout8_5_args = function() {
    return [
      { label: 'W', start: 40, end: 76 },
      { label: 'H', start: 40, end: maxheight },
      { label: 'H1', start: 3, end: maxheight },
      { label: 'H2', start: 3, end: maxheight },
      { label: 'W1', start: 3, end: 76 },
    ];
}

/**** ByPass Sliding Doors Ends ****/

var prepare_measurement_layout = function(){
    var func_name = 'get_layout'+shower_type_id+'_'+shower_layout_id+'_args';
    var $args = eval(func_name + "()");
    const defaultValues = getDefaultDimensions(shower_type_id, shower_layout_id);
    var html = generate_measurement_html($args, defaultValues);

    return html;
}

var generate_option = function(val, selected=''){
    return '<option '+selected+' value="'+val+'">'+ val +'"'+'</option>';
}

var calculate_price = function() {
    var price = 0;
    var func_name = 'get_layout'+shower_type_id+'_'+shower_layout_id+'_args';
    var $args = eval(func_name + "()");

    if ($args.length > 0 ){
        const widths = ["w", "w1", "w2", "w3", "w4", "w5", "w6", "w7"];
        const heights = ["h", "h1", "h2", "h3", "h4", "h5", "h6", "h7"];

        var max_width = 0;
        var max_height = 0;

        console.log($args);

        for( i = 0; i < $args.length; i++ ){
            var label = ($args[i]['label']).toLowerCase();
            if( widths.includes(label) ){
                var width = parseInt( $('select[name="measurement['+i+'][inches]"]').val() );
                var s_type = $('#shower_type').val();
                var s_layout = $('#shower_layout').val();

                if(s_type == "Metro Sliding Shower Doors" || s_type == "ByPass Sliding Shower" || s_layout == 'Corner Fixed Shower Screen to Left Attachment' || s_layout == 'Corner Fixed Shower Screen to Right Attachment'){
                    max_width += width;
                }
                else if( s_type == 'Corner Shower' ){
                    if( s_layout == 'Left Handle Corner Shower Door' || s_layout == 'Left Handle Corner Shower With Notched Panel And Return' || s_layout == 'Left Handle Corner Shower Door With Left Knee Wall' || s_layout == 'Left Handle Corner Shower Door With Right Knee Wall & Glass Hinge' || s_layout == 'Right Open Corner Shower Door With Glass Hinge' || s_layout == 'Right Handle Corner Shower Door With Left Knee Wall' || s_layout == 'Right Handle Corner Shower With Glass To Glass Hinge On Notched Panel With Return' || s_layout == 'Right Handle Corner Shower Door With Right Knee Wall' || s_layout == 'Left Handle Corner Shower Door With Right Panel' || s_layout == 'Left Handle Corner Shower Door With Left Return Panel' || s_layout == 'Left Handle Corner Shower Door With Right Return Panel' || s_layout == 'Right Handle Corner Shower Door With Left Return Panel' || s_layout == 'Right Handle Corner Shower Door With Right Return Panel' ){
                        if( label == 'w' || label == 'w1'){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Left Handle Corner Shower Door & Glass Hinge' || s_layout == 'Left Handle Corner Shower With Glass to Glass Hinge On Notched Panel With Return' || s_layout == 'Right Handle Corner Shower Door' || s_layout == 'Right Handle Corner Shower Door With Notched Panel And Return' || s_layout == 'Right Handle Corner Shower Door With Left Panel' || s_layout == 'Left Handle Corner Shower Door With Left Side Knee Wall' || s_layout == 'Left handle Corner Shower Door With Right Side Knee Wall' || s_layout == 'Right Handle Corner Shower Door With Left Side Knee Wall' || s_layout == 'Right Handle Corner Shower Door With Right Side Knee Wall' ){
                        if( label == 'w' || label == 'w3'){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Phone Booth Corner Shower With Right handle Centered Door' || s_layout == 'Phone Booth Corner Shower With Left handle Centered Door' || s_layout == 'Phone Booth Corner Shower with Door to the Right' || s_layout == 'Phone Booth Corner Shower with Door to the Left' ){
                        if( label == 'w' || label == 'w1' || label == 'w2'){
                            max_width += width;
                        }
                    }
                    else{
                        if( width > max_width){
                            max_width = width;
                        }
                    }
                }
                else if( s_type == 'Neo Angle Showers' ){
                    if( s_layout == 'Left Handle Neo Angle Shower Door With Extra Side Glass' || s_layout == 'Right Handle Neo Angle Shower Door With Extra Side Glass' ){
                        if( label == 'w' || label == 'w1' || label == 'w5'){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Left Handle Neo Angle Shower Door' || s_layout == 'Left Handle Neo Angle Shower Door With Left Knee Wall And Right Panel' || s_layout == 'Left Handle Neo Angle Shower Door With Right Knee Wall' || s_layout == 'Left Handle Neo Angle Shower Door With Two Knee Walls' || s_layout == 'Right Handle Neo Angle Shower Door' || s_layout == 'Right Handle Neo Angle Shower Door With Left Knee Wall' || s_layout == 'Right Handle Neo Angle Shower Door With Right Knee Wall And Left Panel' || s_layout == 'Right Handle Neo Angle Shower Door With Two Knee Walls' ){
                        if( label == 'w' || label == 'w1' || label == 'w2'){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Right Handle Neo Angle Shower Door With Right Side Return Panel' || s_layout == 'Left Handle Neo Angle Shower Door with Left Side Return Panel' || s_layout == 'Right Handle Neo Angle Shower Door With Right Knee Wall' || s_layout == 'Left Handle Neo Angle Shower Door With Left Knee Wall' ){
                        if( label == 'w' || label == 'w1' ){
                            max_width += width;
                        }
                    }
                    else{
                          if( width > max_width){
                            max_width = width;
                        }
                    }
                }
                else if ( s_type == 'Steam Shower' ){
                    if( s_layout == 'Left Handle Corner Shower Door With Left Knee Wall & Transom' || s_layout == 'Left Handle Corner Shower Door With Transom' || s_layout == 'Right Handle Corner Shower Door With Left Knee Wall, Glass Hinge & Transom' || s_layout == 'Right handle Corner Shower Door With Glass Hinge & Transom' ){
                        if( label == 'w' || label == 'w1' ){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Left Handle Corner Shower Door With Glass Hinge & Transom' || s_layout == 'Right handle Corner Shower Door With Right Knee Wall & Transom' || s_layout == 'Right handle Corner Shower Door With Transom' ){
                        if( label == 'w' || label == 'w3' ){
                            max_width += width;
                        }
                    }
                    else if( s_layout == 'Left Handle Neo Angle Shower Door With Left Knee Wall & Transom' || s_layout == 'Left Handle Neo Angle Shower Door With Right Knee Wall & Transom' || s_layout == 'Left Handle Neo Angle Shower Door With Steam Shower Transom' || s_layout == 'Left Handle Neo Angle Shower Door With Two Knee Walls & Transom' || s_layout == 'Right Handle Neo Angle Shower Door With Transom' || s_layout == 'Right Handle neo Angle Shower Door With Left Knee Wall & Transom' || s_layout == 'Right Handle neo Angle Shower Door With Right Knee Wall & Transom' || s_layout == 'Right Handle Neo Angle Shower Door With Two Knee Walls & Transom' ){
                       if( label == 'w' || label == 'w1' || label == 'w2' ){
                            max_width += width;
                        } 
                    }
                    else if( s_layout == 'Left Handle Neo Angle Shower Door With Extra Side Glass & Transom' || s_layout == 'Right Handle Neo Angle Shower Door With Extra Side Glass & Transom' ){
                        if( label == 'w' || label == 'w1' || label == 'w5' ){
                            max_width += width;
                        }
                    }
                    else{
                        if( width > max_width){
                            max_width = width;
                        }
                    }
                }
                else{
                    if( width > max_width){
                        max_width = width;
                    }
                }
            }else if( heights.includes(label) ){
                var height = parseInt( $('select[name="measurement['+i+'][inches]"]').val() );
                if( height > max_height){
                    max_height = height;
                }
            }
        }

        if( max_width > 0 && max_height > 0 ){
            var multiplier = get_price_multiplier();
            price = ( max_width * max_height ) * multiplier;
        }
    }

    const glass_type_price = get_glass_type_price(price);
    const royalty_shield_price = get_royalty_shield_price();
    const handle_style_price = getHandleStylePrice();
    const hardware_finish_price = get_hardware_finish_price();
    const wall_out_of_plumb_price = get_wall_out_of_plumb_price();

    console.log('Base Price: ', price);
    console.log('Glass Type Price: ', glass_type_price);
    console.log('Royalty Shield Price: ', royalty_shield_price);
    console.log('Handle Style Price: ', handle_style_price);
    console.log('Hardware Finish Price: ', hardware_finish_price);

    price = price + glass_type_price + royalty_shield_price + handle_style_price + hardware_finish_price + wall_out_of_plumb_price;

    let percentageIncrease = 10;
    if(shower_type_id === 8) {
        percentageIncrease = 15;
    }

    price += (price * percentageIncrease) / 100;

    console.log('Price: '+ price);
    return price;
}

function getHandleStylePrice() {
  const handleStyle = $('[name="handle_style"]:checked').val();
  console.log(handleStyle)
  return handleStyle ? parseFloat(showerDoorHandleStylePrices[handleStyle]) || 0 : 0;
}

function get_price_multiplier() {
    const glass_thickness = $('[name="glass_thickness"]:checked').val();

    if( glass_thickness == '3/8') {
        return themeSettings.shower_door_thickness_3_8;
    }

    return themeSettings.shower_door_thickness_1_2;
}
    
function get_hardware_finish_price() {
    const hardwareFinish = $('[name="hardware_finish"]:checked').val();
    return hardwareFinish ? parseFloat(showerDoorHardwareFinishPrices[hardwareFinish]) || 0 : 0;
}

function get_wall_out_of_plumb_price() {
  const wall_out_of_plumb = $('input[name="walls_out_of_plumb"]:checked').val();

  if(wall_out_of_plumb === 'Yes') {
    return 100;
  }

  return 0;
}

function get_glass_type_price( base_price ){
    var glass_type = $('input[name="glass_type"]:checked').val();
    if( glass_type == 'Clear Glass' ) {
        return 0;
    }

    if( base_price > 0 ){
        var glass_price = ( base_price * coloredGlassPercentageIncrease ) / 100;

        if( glass_type == 'Clear Glass & Enduro Shield' ){
            glass_price = glass_price > enduroShieldGlassMaxPrice ? enduroShieldGlassMaxPrice : glass_price;
        }
    }
    return glass_price;
}

function get_royalty_shield_price() {
  const royalty_shield = $('input[name="royalty_shield"]:checked').val();

  if(royalty_shield === 'Yes') {
    return 50;
  }

  return 0;
}

function generate_measurement_html(args, defaultValues = {}){
    var html = '';
    const {width, height, w1, w2, w3, h1, h2} = defaultValues;

    const mapping = {
        w1: w1,
        w2: w2,
        w3: w3,
        w: width,
        h1: h1,
        h2: h2,
        h: height
    };

    for( i = 0; i < args.length; i++ ) {
        const lowercaseLabel = args[i]['label'].toLowerCase();
        const key = Object.keys(mapping).find(k => lowercaseLabel.includes(k));
        const match = key ? mapping[key] : 0;

        html+= '<li><span>'+args[i]['label']+' (Inch):</span> <div class="tbdf-22"><input type="hidden" name="measurement['+i+'][label]" value="'+args[i]['label']+'"/><select class="form-control" name="measurement['+i+'][inches]">';
        for (var j = args[i]['start']; j <= args[i]['end']; j++) {
            const selected = match === j ? 'selected' : '';
            html += generate_option(j, selected);
        }
        html+='</select></div></li>';
        html+= '<li><span>Fraction an  Inch:</span> <div class="tbdf-22"><select class="form-control measurement" name="measurement['+i+'][fraction]">';
            for (var k = 0; k < fraction_array.length; k++) {
              html += generate_option(fraction_array[k]);
            }
        html+='</select></div></li>';
    }

    return html;
}

const updateMeasurementImageProperty = function (image) {
   measurementImageUrl = image || finalMeasurementImage.attr('src');
}

const createMeasurementImage = () => {
    const properties = get_properties();

    finalMeasurementImgContainer.addClass('loading_preview');

    var data = {
      title: 'Shower Door',
      properties: properties
    };

    var params = {
        type: 'POST',
        url: createMeasurementImageUrl,
        data: data,
        dataType: "json"
    };

    $.ajax(params)
    .done(
        function(response) {
          if (response.success) {
              const imageUrl = response.image_url;
              updateMeasurementImageProperty(imageUrl);
              $('.zoom_button').attr('href', imageUrl);
            
              finalMeasurementImage.attr('src', imageUrl)
              .on('load', function() {
                finalMeasurementImgContainer.removeClass('loading_preview');

                if (!finalMeasurementImage.parent().is('a')) {
                    finalMeasurementImage.wrap('<a href="' + imageUrl + '" class="cursor-zoom-in fancybox"></a>');
                } else{
                    finalMeasurementImgContainer.find('a').attr('href', imageUrl);
                }
                $('.fancybox').fancybox();
              });
          }
      }.bind(this)
    )
    .fail(
        function(response) {
          console.log(response);
        }.bind(this)
    );
}

/**
 * Updates the visibility of the Oil Rubbed Bronze hardware finish option based on the shower type ID.
 * @param {number} shower_type_id - The ID of the shower type.
 */
const updateHardwareFinishOptions = (shower_type_id) => {
    // Select the parent element of the Oil Rubbed Bronze option
    const oilRubbedOption = $('#radio_hf_Oil_Rubbed_Bronze').parent();

    // Array of shower type IDs for which the Oil Rubbed Bronze option should be hidden
    const hiddenShowerTypes = [7, 8];
    hiddenShowerTypes.includes(shower_type_id) ? oilRubbedOption.hide() : oilRubbedOption.show();
}

const modifyLayoutByCustomerSelection = (step) => {
    if(step === 5) {
       const showerType = $('#shower_type').val().trim().toLowerCase();
       modifyStep5Layout(showerType);
    }
}

// Function to modify the configuration of step 5 based on the selected shower type
const modifyStep5Layout = (showerType) => {
    console.log(`Shower type is: ${showerType}`);
    const installationStyleContainer = $('#shower_installation_style');
    const handleStyleContainer = $('#shower_handle_style');
    const handleStyleRadios = $('[name="handle_style"]');

    let defaultHandleStyle = $('#hs-6-inch-most-popular');
    const pullHandle = '#hs-pull-handle';

    /** Remove handle style from step 5 if Fixed Shower Screen is selected by customer **/
    if (showerType === 'fixed shower screen') {
        installationStyleContainer.removeClass('d-none');
        handleStyleContainer.addClass('d-none');
    } else {
        handleStyleContainer.removeClass('d-none');
        installationStyleContainer.addClass('d-none');
    }

    // If the selected shower type is 'bypass sliding shower'
    if (showerType === 'bypass sliding shower') {
         handleStyleRadios.not(pullHandle).closest('.handle-option').hide();
         defaultHandleStyle = $(pullHandle);
    } else {
        // For any other shower type, show all handle style radio buttons
        handleStyleRadios.closest('.handle-option').show();
    }

    defaultHandleStyle.trigger('click');
}

$( document ).ready(function() {
    handleSizeEl = $('#shower_handle_style .custom_select');
    finalMeasurementImgContainer = $('#shower-step6 figure');
    finalMeasurementImage = $('#shower-step6 .measurement_selected_image');

    /*** Shower type Step1 ***/
	$( ".shower--type" ).click(function() {
      	var ths = $(this);

		shower_type_id = ths.data('shower-type-id');

      	$('.shower-layout').addClass('hidden');
		$('#shower-layout-'+shower_type_id).removeClass('hidden');
      	$('#shower_type').val(ths.data('val'));

      	navigate_to_step(2);
        updateHardwareFinishOptions(shower_type_id);
	});

  	/*** Shower layout Step2 ***/
  	$('.shower--layout').click(function(){
      	var ths = $(this);
      	var measurement_image = ths.find('.measurement_image').val();
  		$('#shower_layout').val(ths.data('val'));
      	$('#measurement_image').val(measurement_image);
      	shower_layout_id = ths.data('shower-layout-id');
      	$('.measurement_selected_image').attr('src', measurement_image)
      	var html = prepare_measurement_layout();
      	$('#select-shower-dimestions').html(html);

      	var angles_html = get_shower_angles_html();
      	$('#shower_angles').html(angles_html);

      	navigate_to_step(3);
  	});

  	/*** Navigation step heads ***/
	$(document).on('click', '.active-tab-heads', function(){
  		var step = $(this).data('step');
      	navigate_to_step(step);
	});

	$('.navigation_btn').click(function() {
  		var current_step = $(this).data('step');
      	var action = $(this).data('action');

        if(action == 'next') {
          var step = current_step + 1;
        } else {
          var step = current_step - 1 ;
        }

        modifyLayoutByCustomerSelection(step);
      	navigate_to_step(step);
	});

    // Add icon dynamically
    $('.image-container').append('<div class="icon">Your Icon or Magnifier Icon</div>');

    // Set hover effect
    $('.image-container').on('mouseenter', function() {
        $(this).find('.icon').css('opacity', '1');
    });

    $('.image-container').on('mouseleave', function() {
        $(this).find('.icon').css('opacity', '0');
    });

	$(document).on('change', '#angle_defaults', function(){

		if($(this).is(':checked')){
			$('#__angles_block').removeClass('active');
        }else{
			$('#__angles_block').addClass('active');
        }
	});

    $('#qty_minus_btn').click(function(){
        var qty = parseInt($('#quantity').val());
        if( qty > 1 ){
        	qty--;
        }
        quantity = qty;
      	$('#quantity').val(qty);
        display_price();
    });

    $('#qty_plus_btn').click(function(){
        var qty = parseInt($('#quantity').val());
        qty++;
        quantity = qty;
    	$('#quantity').val(qty);
        display_price();
    });

    $('input[name="handle_style"]').change(function(){
       const handleStyle = $('input[name="handle_style"]:checked').val();

       if ($.inArray(handleStyle, handleSizeEnabledFor) === -1) {
            handleSizeEl.hide();
        } else {
           handleSizeEl.show();
        }
    });

	$('.get_order_summary').click(function() {
        createMeasurementImage();

        const handleStyle = $('input[name="handle_style"]:checked').val();
        let textHandleStyle = handleStyle;

        if ($.inArray(handleStyle, handleSizeEnabledFor) !== -1) {
            const handleSize = $('#handle_size').val();
            textHandleStyle = `${handleStyle} (${handleSize})`;
        }

      	var measurement_html = get_measurement_html();
      	$('#rm__measurement_table').html(measurement_html);
		$('.cs__selected_glass_type').text($('input[name="glass_type"]:checked').val());
      	$('.cs__selected_glass_thickness').text($('input[name="glass_thickness"]:checked').val());
      	$('.cs__selected_handle_style').text(textHandleStyle);
        $('.cs__selected_installation_style').text($('input[name="installation_style"]:checked').val());
      	$('.cs__selected_hardware_finish').text($('input[name="hardware_finish"]:checked').val());

        var shower_type = $('#shower_type').val();
        shower_type = shower_type.trim().toLowerCase();
        if( shower_type == 'fixed shower screen' ){
            $('#installation_style_summary').removeClass('d-none');
            $('#handle_style_summary').addClass('d-none');
        }
        else{
            $('#handle_style_summary').removeClass('d-none');
            $('#installation_style_summary').addClass('d-none');
        }

  		navigate_to_step(6);
	});

    $('#add_to_cart').click(function () {
        $(this).addClass('loading');
        var properties = get_properties();

        var data = {
          title: 'Shower Door',
          price: unit_price,
          properties: properties
        };

        var params = {
            type: 'POST',
            url: createShopifyProductUrl,
            data: data,
            dataType: "json"
        };

        /**** Create product on shopify ****/
        $.ajax(params)
        .done(
            function(response) {
                const product = response.product;
                const id = product.variants[0].id; //variant id, send it when add to cart

                // Update measurement image property
                const productImage = product.image.src;
                updateMeasurementImageProperty(productImage); // This property will be used to show the dimensions customer ordered.

                //Measure image modified, fetch properties again
                const properties = get_properties();

                //Product created using shopify admin api.. add to cart it now.
                addToCart(id, properties);
          }.bind(this)
        )
        .fail(
            function(response) {
              console.log(response);
            }.bind(this)
        );
    });

    window.onhashchange = function() {
        var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
        var step = parseInt( hash.replace("step", "") );
        if( isNaN( step ) || step <= 0 || step > 6 ) {
            step = 1;
        }
        navigate_to_step( step, false );
    }
});

class ShowerNavigator {
  constructor() {
    this.showerTypeElements = this.getShowerTypeElements();
    this.showerTypeLayoutElements = this.getShowerTypeLayoutElements();
  }

  /**
   * Gets an object that maps shower types to their corresponding element selectors.
   * @returns {Object}
   */
  getShowerTypeElements() {
    return {
      fixed: '[data-val="Fixed Shower Screen"]',
      swing: '[data-val="Single Swing Doors"]',
      door_panel: '[data-val="Door & Panel Shower Doors"]',
      corner: '[data-val="Corner Shower"]',
      neo_angle: '[data-val="Neo Angle Showers"]',
      steam: '[data-val="Steam Shower"]',
      metro: '[data-val="Single Sliding Shower Doors"]',
      bypass: '[data-val="ByPass Sliding Shower"]'
    };
  }

  /**
   * Gets an object that maps shower type and layout combinations to their corresponding element selectors.
   * @returns {Object}
   */
  getShowerTypeLayoutElements() {
    const fixed = {
      left_attachment: '[data-val="Fixed Shower Screen to Right Attachment"]',
      right_attachment: '[data-val="Fixed Shower Screen to Left Attachment"]',
      left_attachment_notch: '[data-val="Fixed Shower Screen to Left Attachment"]',
      right_attachment_notch: '[data-val="Fixed Shower Screen to Left Attachment"]',
      corner_left_attachment: '[data-val="Corner Fixed Shower Screen to Left Attachment"]',
      corner_right_attachment: '[data-val="Corner Fixed Shower Screen to Right Attachment"]'
    };
  
    const swing = {
      right_handle: '[data-val="Right Handle Single Shower Door"]',
      left_handle: '[data-val="Left Handle Single Shower Door"]',
      dual_glass: '[data-val="Dual Glass Shower Doors"]'
    };
  
    const doorPanel = {
      left_handle_with_two_panel: '[data-val="Left handle Door With Two Panel Shower Door"]',
      left_handle_with_single_panel: '[data-val="Left Handle Door With Single Panel Shower Door"]',
      left_handle_with_right_panel: '[data-val="Left Handle Door With Right Panel Shower Door"]',
      left_handle_with_left_knee_wall: '[data-val="Left Handle Shower Door Panel With Left Knee Wall"]',
      left_handle_with_right_knee_wall: '[data-val="Left Handle Shower Door Panel With Right Knee Wall"]',
      left_open_with_two_knee_walls: '[data-val="Left Open Shower Door Panel With Two Knee Walls"]'
    };
  
    const metro = {
      left_sliding: '[data-val="Metro Left Sliding Shower Door"]',
      left_sliding_corner: '[data-val="Metro Left Sliding Corner Shower Door"]',
      left_sliding_with_right_knee: '[data-val="Metro Left Sliding Shower Door With Right Knee Wall"]',
      right_sliding: '[data-val="Metro Right Sliding Shower Door"]',
      right_sliding_corner: '[data-val="Metro Right Sliding Corner Shower Door"]',
      right_sliding_with_left_knee: '[data-val="Metro Right Sliding Corner Shower Door With Left Knee Wall"]'
    };
  
    const bypass = {
      linear: '[data-val="Linear Bypass Sliding Shower Door"]',
      linear_with_left_corner: '[data-val="Linear Bypass Sliding Shower Door"]',
      linear_with_right_corner: '[data-val="Linear Bypass Sliding Shower Door"]'
    };
  
    return {
      fixed,
      swing,
      door_panel: doorPanel,
      metro,
      bypass
    };
  }

  /**
   * Retrieves the shower type and layout from session storage.
   * @returns {[string, string]} An array with the shower type and layout.
   */
  getShowerTypeAndLayout() {
    const showerLayout = sessionStorage.getItem('shower_layout');
    if (showerLayout && showerLayout.trim() !== '') {
      const [type, layout] = showerLayout.split('->').map(part => part.toLowerCase().trim().replace(/\s/g, '_'));
      return [type, layout];
    }
    return ['', ''];
  }

  /**
   * Navigates to step 3 using the retrieved shower type and layout.
   * @returns {Promise<void>}
   */
  async navigateToStep3() {
    const [type, layout] = this.getShowerTypeAndLayout();
    const selector = this.showerTypeElements[type];

    if (selector) {
      const element = $(selector);
      showerTypeHandler(element);

      const layoutSelector = this.showerTypeLayoutElements[type]?.[layout];
      if (layoutSelector) {
        const element = $(layoutSelector);
        showerLayoutHandler(element);
      }
    }

    sessionStorage.removeItem("shower_layout");
  }

  /**
   * Waits for an element to be available in the DOM and returns it.
   * @param {string} selector - The CSS selector for the element.
   * @param {number} [timeout=10000] - The maximum time to wait for the element (in milliseconds).
   * @returns {Promise<HTMLElement|null>}
   */
  async waitAndGetElement(selector, timeout = 10000) {
    const startTime = Date.now();
    let element = null;

    while (!element && Date.now() - startTime < timeout) {
      element = $(selector);
      if (!element) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    return element;
  }
}

// Usage example
const showerNavigator = new ShowerNavigator();
showerNavigator.navigateToStep3();